export default "__VITE_ASSET__e31fba71__"